import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TrocarFotoComponent } from './trocar-foto.component';

const routes: Routes = [{ path: '', component: TrocarFotoComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TrocarFotoRoutingModule { }
